export default "__VITE_ASSET__Cez1nEfe__"